module.exports = __webpack_public_path__ + "img/banner1.9a033655.png";